import CobranzaImport from "./CobranzaImport";

export {CobranzaImport}
export default CobranzaImport
